import { createContext } from 'react';
import type { OnboardingMoralPersonSaveStepsType } from './types';

const OnboardingMoralPersonSaveSteps =
  createContext<OnboardingMoralPersonSaveStepsType>(
    {} as OnboardingMoralPersonSaveStepsType,
  );

export default OnboardingMoralPersonSaveSteps;
